// ============================================================================
// @gs/i18n/GsLocaleProvider — branche le contexte locale leger sur i18next
// ============================================================================
// Monte par les apps MIGREES i18n (pilotes : ug). Fournit { locale, setLocale }
// au LocaleContext (consomme par GsUserMenu pour le selecteur Langue vivant).
// setLocale delegue a config.setLocale (changeLanguage + localStorage +
// <html lang>). Les apps sans provider : useLocale() = null, controle masque.

import React, { useCallback, useState } from 'react';
import i18next from 'i18next';
import { LocaleContext, DEFAULT_LOCALE, SUPPORTED_LOCALES } from './localeContext';
import type { SupportedLocale } from './localeContext';
import { applyCompanyLocale as applyCompanyDefault, setLocale as applyLocale } from './config';

function currentLocale(): SupportedLocale {
  const lang = (i18next.language ?? '').split('-')[0].toLowerCase();
  return SUPPORTED_LOCALES.includes(lang as SupportedLocale)
    ? (lang as SupportedLocale)
    : DEFAULT_LOCALE;
}

export function GsLocaleProvider({ children }: { children: React.ReactNode }) {
  const [locale, setLocaleState] = useState<SupportedLocale>(() => currentLocale());

  const setLocale = useCallback((next: SupportedLocale) => {
    setLocaleState(next);
    void applyLocale(next);
  }, []);

  // La langue de la compagnie ne persiste rien : l'etat React suit la langue reellement appliquee.
  const applyCompanyLocale = useCallback((raw: string | null | undefined) => {
    void applyCompanyDefault(raw)
      .then((applied) => {
        if (applied) setLocaleState(applied);
      })
      .catch(() => {
        // Fail-soft : la langue de la compagnie ne bloque jamais l'app, la langue en place reste.
      });
  }, []);

  return (
    <LocaleContext.Provider value={{ locale, setLocale, applyCompanyLocale }}>
      {children}
    </LocaleContext.Provider>
  );
}
